module.exports = __webpack_public_path__ + "3d41e3ac764fcee300ee293bf4c15cb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/load.svg
// module id = 760
// module chunks = 0